import merge from 'lodash/merge';
import DBHandler from '../index-db/db-handler';
import { db } from '../index-db/db';
import { GLOBAL_VARS, SPORT_LIST, LOCKS, SPORT_BASE, refresh_sport_base} from './globalVars';
import { SME_CON, API_CONTROL } from './api-connection';
import { ConfirmModel, Get_Device_Type, isHotLoad, Get_Date, UsingLock, Sleep } from '../utils/utils';
import { free_app_status } from '../sport/sport-function';
import SportSelector from '../../components/sport-selector/sport-selector';
import RegisterDevice from '../../components/register_device/register_device';
import { is_active_match } from '../sport/sport-function';
import { Date_Convert_Timezone } from '../utils/utils';
import dayjs from "dayjs";

// dayjs.extend(utc);
// dayjs.extend(timezone);


class Sync {
   sme_con = null;
   apt_control = null;
   db_handler = null;
   SYNC_WATCH_COUNT = 0;

   constructor(authObj, args = {}) {
      // console.log('>>>-------+ Starting  Sync: args', args);
      this.sme_con = new SME_CON(authObj);
      this.apt_control = API_CONTROL({ sme_con: this.sme_con });
      this.db_handler = DBHandler();
   }


   init_hot_load = () => {
      return new Promise(async (resolve) => {
         try {
            // console.log('>>> SYNC INIT <<<');
            // >>> What for sme_con         
            while (!this.sme_con.ready) {
               if (this.sme_con.client === false) {
                  resolve(false);
                  return
               }
               await Sleep(50);
            }

            this.connection_watch();

            await Sleep(2000);
            while (GLOBAL_VARS.server_connection !== true) {
               console.log('Waiting for server_connection.....')
               resolve(false);
               await Sleep(1000);
            }


            const { account_details, club_details, club_ads } = await this.get_account_data();
            
            const account_data = await this.get_account_data();
            // console.log('testingX: ', account_data);

            if (account_data !== null) {
               await this.db_handler.update_settings({
                  sport: account_data.sport_type,
                  free_app: false
               });
            }


            console.log('account_details: ', account_details);
            // console.log('club_details: ', club_details);
            // console.log('club_ads: ', club_ads);

            const update_account_result = await this.db_handler.update_account(account_details);
            // console.log('update_account_result: ', update_account_result);

            const club_update = JSON.parse(JSON.stringify(club_details[0]));
            club_update.ad_1 = club_ads.ad1.path;
            club_update.ad_2 = club_ads.ad2.path;
            club_update.ad_3 = club_ads.ad3.path;

            const update_club_result = await this.db_handler.update_club(club_update);
            const load_settings_result = await this.db_handler.load_settings();
            console.log('load_settings_result: ', load_settings_result);
            const update_sync_data_result = await this.update_sync_data();
           
           
            console.error('>>> SYNC INIT COMPLETED <<<');
            
            resolve(true);
         } catch (error) {
            console.error('ERROR - Sync - init_hot_load - unexpected error: ', error);
            resolve(false);
         }
      });
   }

   init = () => {
      return new Promise(async (resolve) => {
         try {
            // console.log('>>> SYNC INIT <<<');
            // >>> What for sme_con         
            while (!this.sme_con.ready) {
               if (this.sme_con.client === false) {
                  resolve(false);
                  return
               }
               await Sleep(50);
            }

            this.connection_watch();


            


            await Sleep(2000);
            while (GLOBAL_VARS.server_connection !== true) {
               console.log('Waiting for server_connection.....')
               resolve(false);
               await Sleep(1000);
            }
           
            const { account_details, club_details, club_ads } = await this.get_account_data();

            if (typeof account_details === 'undefined') {
               console.error('ERROR - Sync - init - account_details - Unexpected error');
               resolve(false);
               return
            }
            // console.log('account_details XA: ', account_details);

            // >>> Update Account         
            const update_account_result = await this.db_handler.update_account(account_details);
            if (!update_account_result) {
               console.log('update_account_result: ', update_account_result);
               console.error('ERROR - Sync - init - update_account - Unexpected error');
               console.warn('TODO This not show if offline....');
               ConfirmModel({
                  icon: 'error',
                  title: `Device Registration Error`,
                  text: 'Please reset browser cache or contact support. Error: E01',
                  confirmButtonText: 'Ok',
                  allowOutsideClick: true,
                  showCancelButton: false,
                  footer: `<a href="mailto:support@scoringmadeeasy.com">support@scoringmadeeasy.com</a> <br /> <br /> <br /> <a href="/delete-db">Reset DB</a>`
               });
            }

            


            if (club_details.length > 0) {
               // >>> Pick Club
               let selected_club = 0;
               if (club_details.length > 1) {
                  // TODO Create a Club Picker for Accounts with more that one Club
                  // selected_club = club_picker()
               }

               let club_update = JSON.parse(JSON.stringify(club_details[selected_club]));
               club_update.ad_1 = club_ads.ad1.path;
               club_update.ad_2 = club_ads.ad2.path;
               club_update.ad_3 = club_ads.ad3.path;

               const update_club_result = await this.db_handler.update_club(club_update);
               if (!update_club_result) {
                  console.error('ERROR - Sync - init - update_club - Unexpected error');
                  ConfirmModel({
                     icon: 'error',
                     title: `Device Registration Error`,
                     text: 'Please reset browser cache or contact support. Error: E02',
                     confirmButtonText: 'Ok',
                     allowOutsideClick: true,
                     showCancelButton: false,
                     footer: `<a href="mailto:support@scoringmadeeasy.com">support@scoringmadeeasy.com</a> <br /> <br /> <br /> <a href="/delete-db">Reset DB</a>`
                  });
               }

               const load_settings_result = await this.db_handler.load_settings();
               const deviceSettings = typeof load_settings_result === 'undefined' ? false : load_settings_result;
               if (!deviceSettings) {
                  await this.select_sport();
                  Sleep(100);
                  refresh_sport_base();
                  await ConfirmModel({
                     icon: 'success',
                     title: `Sport Selection Complete`,
                     confirmButtonText: 'Ok',
                     allowOutsideClick: true,
                     showCancelButton: false,
                  });
               }

               const load_sync_result = await this.db_handler.load_sync();
               const deviceRegistered = typeof load_sync_result === 'undefined' ? false : load_sync_result;
               // console.log('DEBUG ----- deviceRegistered: ', deviceRegistered);
               if (!deviceRegistered) {
                  await this.register_device();
                  Sleep(100);
                  ConfirmModel({
                     icon: 'success',
                     title: `Device Registration Complete`,
                     confirmButtonText: 'Ok',
                     allowOutsideClick: true,
                     showCancelButton: false,
                  });

                  await this.update_sync_data();
               } else {
                  // >>> Update Linked Court information
                  await this.update_sync_data();
                  // try {
                  //    const selected_court = court_details.filter(i => i.device_id === deviceRegistered.device_id);
                  //    await this.db_handler.update_sync({
                  //       device_id: deviceRegistered.device_id,
                  //       device_name: deviceRegistered.device_name,
                  //       ccfg_id: selected_court.length !== 0 ? selected_court[0].ccfg_id : 0,
                  //       court_name: selected_court.length !== 0 ? selected_court[0].court_name : '',
                  //       court_image: selected_court.length !== 0 ? selected_court[0].court_image : '',
                  //       sub_courts: sub_courts,
                  //       sync_limit: sync_usage,
                  //    });
                  // } catch (error) {
                  //    console.error('ERROR - Sync - init - Update Device/Court - Unexpected error: ', error);
                  // }
               }
            } else {
               console.error('User has no Club');
            }




            await this.db_handler.update_settings({
               free_app: GLOBAL_VARS.free_app
            });



            // Blocks Free Apps.
            if (free_app_status()) {
               console.log('No Subscription - Exiting');
               resolve(false);
               return;
            }




         } catch (error) {
            console.error('ERROR - Sync - init - Unexpected error: ', error);
            ConfirmModel({
               icon: 'error',
               title: `Device Registration Error`,
               text: 'Please contact support. Error: E05',
               confirmButtonText: 'Ok',
               allowOutsideClick: true,
               showCancelButton: false,
               footer: `<a href="mailto:support@scoringmadeeasy.com">support@scoringmadeeasy.com</a> <br /> <br /> <br /> <a href="/delete-db">Reset DB</a>`
            });
            resolve(false);
         }
         
         // NAV_CONTROL.openMainMenuMatchHistory();
         // Sleep(100);
         // NAV_CONTROL.openMainMenuNew();
         resolve(false);
      });
   }

   update_sync_data = () => {
      return new Promise(async (resolve) => {
         try {
            if (GLOBAL_VARS.server_connection) {
               const { court_details, sub_courts, sync_usage } = await this.get_account_data();
               const load_sync_result = await this.db_handler.load_sync();
               const deviceRegistered = typeof load_sync_result === 'undefined' ? false : load_sync_result;
               // console.log('deviceRegistered: ', deviceRegistered);
               // console.log('court_details: ', court_details);
               try {
                  let device_id = 0;
                  let device_name = '';
                  let ccfg_id = 0;
                  let court_name = '';
                  let court_image = '';

                  if (isHotLoad()) {
                     device_name = 'Hot Device';
                     ccfg_id = court_details?.[0]?.ccfg_id || 0;
                     court_name = court_details?.[0]?.court_name || '';
                     court_image = court_details?.[0]?.court_image || '';
                    
                  } else {
                     device_id = deviceRegistered.device_id;
                     device_name = deviceRegistered.device_name;
                     const selected_court = court_details.filter(i => parseInt(i.device_id) === parseInt(deviceRegistered.device_id));
                     ccfg_id = selected_court.length !== 0 ? selected_court[0].ccfg_id : 0;
                     court_name = selected_court.length !== 0 ? selected_court[0].court_name : '';
                     court_image = selected_court.length !== 0 ? selected_court[0].court_image : '';
                  }

                  // console.log('device_id: ', device_id);
                  // console.log('device_name: ', device_name);
                  // console.log('ccfg_id: ', ccfg_id);
                  // console.log('court_name: ', court_name);
                  // console.log('court_image: ', court_image);
                  // console.log('sub_courts: ', sub_courts);
                  // console.log('sync_usage: ', sync_usage);

                  await this.db_handler.update_sync({
                     device_id: device_id,
                     device_name: device_name,
                     ccfg_id: ccfg_id,
                     court_name: court_name,
                     court_image: court_image,
                     sub_courts: sub_courts,
                     sync_limit: sync_usage,
                  });
               } catch (error) {
                  console.error('ERROR - Sync - init - Update Device/Court - Unexpected error: ', error);
               }
            }
            resolve(true);
         } catch (error) {
            console.error('ERROR - update_sync_data - root: ', error);
            resolve(false);
         }
      });
   }



   get_account_data = () => {
      if (isHotLoad()) {
         return this.get_account_data_hot_load();
      } else {
         return this.get_account_data_standard();
      }
   }
   

   get_account_data_hot_load = () => {
      return new Promise(async (resolve) => {
         try {
            const court = GLOBAL_VARS.session_storage.get_court();
            const match_helper_by_court_result = await this.apt_control.SME.query.match_helper_by_court(court);
            match_helper_by_court_result.club_details = [match_helper_by_court_result.club_details];
            match_helper_by_court_result.court_details = [match_helper_by_court_result.court_details]; 
            match_helper_by_court_result.sync_usage = match_helper_by_court_result.sync_usage.Result; 
            GLOBAL_VARS.free_app = false; // Make sure we are not free app
            
            resolve({
               ...match_helper_by_court_result,
               device_list: [],
               device_id: null,
            });

            resolve(false);
         } catch (error) {
            console.error('ERROR - get_account_data_hot_load - root: ', error);
            resolve(false);
         }
      });
   }

   
   get_account_data_standard = () => {
      return new Promise(async (resolve) => {
         try {
            const sport_type = SPORT_BASE.sport_name;
            const load_sync_result = await this.db_handler.load_sync();
            const device_id = typeof load_sync_result !== 'undefined' && load_sync_result !== null ? load_sync_result.device_id : 0;
            const account_details = await this.apt_control.SME.query.account_details();
            const club_details = await this.apt_control.SME.query.user_clubs(account_details.user_id);
            const device_list_query = await this.apt_control.SME.query.club_devices(account_details.user_id);
            const scoring_subs = await this.apt_control.SME.query.user_payments(account_details.user_id, 0);
            const sync_usage = await this.apt_control.SME.query.sync_usage(account_details.user_id, device_id);
            // console.warn('[DEBUG] get_account_data_standard - sport_type: ', sport_type);
            const club_ads = club_details.length > 0 ? await this.apt_control.SME.query.club_ads(club_details[0].club_id, sport_type) : null;
            // console.warn('[DEBUG] get_account_data_standard - club_ads: ', club_ads);
            const court_details = club_details.length > 0 ? await this.apt_control.SME.query.club_courts(club_details[0].club_id, sport_type) : null;
            const device_list = device_list_query !== false ? device_list_query : [];
            const sub_courts = scoring_subs.reduce((a, i) => a + i.py_for_users, 0) || 0;
            device_list.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

            // console.log('>>>>>> sub_courts: ', sub_courts);

            if (sub_courts === 0) { GLOBAL_VARS.free_app = true; }
            else {
               GLOBAL_VARS.free_app = sync_usage.Result === false ? true : false;
            }

            resolve({
               sport_type: sport_type,
               account_details: account_details,
               club_details: club_details,
               club_ads: club_ads,
               court_details: court_details,
               device_list: device_list,
               sub_courts: sub_courts,
               sync_usage: sync_usage.Result,
               device_id: device_id,
            });
         } catch (error) {
            console.error('Error get_account_data: Unexpected Error: ', error);
            resolve('Error');
         }
      });
   }

   select_sport = () => {
      return new Promise(async (resolve) => {
         try {
            console.log('>>>>> select_sport');
            console.log('SPORT_LIST: ', SPORT_LIST);
            const sport_result = await this.select_sport_model();
            console.log('sport_result: ', sport_result);
            if (sport_result !== false) {
               console.log('Updating update_settings for sport')
               await this.db_handler.update_settings({
                  setting_id: 1,
                  sport: sport_result.name,
                  free_app: GLOBAL_VARS.free_app
               });
               resolve(true);
            } else {
               this.select_sport();
            }
         } catch (error) {
            console.error('Error select_sport: Unexpected Error: ', error);
         }
      });
   }


   select_sport_model = () => {
      return new Promise(async (resolve) => {
         const select_sport = async (sport_id) => {
            const sport = SPORT_LIST.filter(i => i.id === sport_id)
            ConfirmModel({
               html: (<SportSelector text={'Confirm Selection'} sport_list={sport} />),
               confirmButtonText: 'Yes',
               showCancelButton: true,
               allowOutsideClick: false,
               css_popup: 'swalPopup_theme_1',
               css_title: 'swalTitle_theme_1',
            }).then((result) => {
               if (result.isConfirmed) {
                  resolve(sport[0]);
               } else {
                  sport_picker();
               }
            });
         }
         const sport_picker = () => {
            ConfirmModel({
               html: (<SportSelector text={'Select Sport'} sport_list={SPORT_LIST} select_callback={select_sport} />),
               showConfirmButton: false,
               showCancelButton: false,
               allowOutsideClick: false,
               width: '100%',
               grow: 'fullscreen',
               css_popup: 'swalPopup_theme_1',
            });
         }
         sport_picker();
      });
   }

   register_device = (allow_close = false) => {
      return new Promise(async (resolve) => {
         try {
            const { sport_type, account_details, court_details, device_list, sub_courts, sync_usage } = await this.get_account_data();
            const tokens = await this.sme_con.auth.get_token();
            const filtered_device_list = device_list.filter(i => i.name !== "Unset");
            const result = await this.register_device_model(filtered_device_list, allow_close, {
               type: Get_Device_Type(),
               sport_type: sport_type,
               user_id: account_details.user_id,
               identifier: tokens.deviceID,
            });

            if (result === false) {
               await this.db_handler.update_sync({
                  device_id: 0,
                  ccfg_id: 0,
                  court_name: '',
                  court_image: '',
                  sub_courts: 0,
                  sync_limit: true,
               });
            } else {
               const selected_court = court_details.filter(i => i.device_id === result.device_id);
               const sync_object = {
                  device_id: result.device_id,
                  ccfg_id: selected_court.length > 0 ? selected_court[0].ccfg_id : 0,
                  device_name: result.name,
                  court_name: selected_court.length > 0 ? selected_court[0].court_name : '',
                  court_image: selected_court.length > 0 ? selected_court[0].court_image : '',
                  sub_courts: sub_courts,
                  sync_limit: sync_usage,
               }
               await this.db_handler.update_sync(sync_object);

               console.warn('>>>>>> sport_type: ', sport_type);

               await this.apt_control.SME.mutation.update_device(sync_object.device_id, {
                  sport_type: sport_type,
                  identifier: tokens.deviceID,
               });
            }

            resolve(true);
         } catch (error) {
            console.error('Error register_device: Unexpected Error: ', error);
         }
      });
   }

   register_device_model = (device_list, allow_close = false, args = {}) => {
      return new Promise(async (resolve) => {
         const select_device = async (device_id) => {
            const device = device_list.filter(i => i.device_id === device_id)
            ConfirmModel({
               title: `Confirm Selection`,
               html: (<RegisterDevice device_list={device} allow_close={allow_close} />),
               confirmButtonText: 'Yes',
               showCancelButton: true,
               allowOutsideClick: false,
               css_popup: 'swalPopup_theme_1',
               css_title: 'swalTitle_theme_1',

            }).then((result) => {
               if (result.isConfirmed) {
                  resolve(device[0]);
               } else {
                  device_picker();
               }
            });
         }
         const new_device = (name) => {
            const new_device = [{ name: name, device_id: null }];
            ConfirmModel({
               title: `Register new device?`,
               html: (<RegisterDevice device_list={new_device} allow_close={allow_close} />),
               confirmButtonText: 'Yes',
               showCancelButton: true,
               allowOutsideClick: true,
               showLoaderOnConfirm: true,
               css_popup: 'swalPopup_theme_1',
               css_title: 'swalTitle_theme_1',

               preConfirm: async (confirm) => {
                  try {

                     console.warn('>>>>>> new_device - Sport Type: ', args);
                     console.warn('>>>>>> new_device - Sport Type: ', args.sport_type);

                     const result = await this.apt_control.SME.mutation.create_device({
                        name: name,
                        sport_type: args.sport_type,
                        type: args.type,
                        user_id: args.user_id,
                        identifier: args.identifier
                     });
                     if (result !== false) {
                        resolve(result);
                        return true;
                     } else {
                        ConfirmModel({
                           icon: 'error',
                           title: `Device Registration Error`,
                           text: 'Please contact support. Error: E03',
                           confirmButtonText: 'Ok',
                           allowOutsideClick: true,
                           showCancelButton: false,
                           footer: `<a href="mailto:support@scoringmadeeasy.com">support@scoringmadeeasy.com</a> <br /> <br /> <br /> <a href="/delete-db">Reset DB</a>`
                        });
                        return false;
                     }
                  } catch (error) {
                     ConfirmModel({
                        icon: 'error',
                        title: `Device Registration Error`,
                        text: 'Please contact support. Error: E04',
                        confirmButtonText: 'Ok',
                        allowOutsideClick: true,
                        showCancelButton: false,
                        footer: `<a href="mailto:support@scoringmadeeasy.com">support@scoringmadeeasy.com</a> <br /> <br /> <br /> <a href="/delete-db">Reset DB</a>`
                     });
                     console.error('Error register_device_model - new_device: Unexpected Error');
                     return false;
                  }
               }
            }).then((result) => {
               if (!result.isConfirmed) {
                  device_picker();
               }
            });
         }
         const device_picker = () => {
            ConfirmModel({
               html: (<RegisterDevice device_list={device_list} show_new_device={true} new_device_callback={new_device} select_callback={select_device} allow_close={allow_close} />),
               confirmButtonText: 'Ok',
               cancelButtonText: 'Skip',
               showConfirmButton: false,
               showCancelButton: false,
               allowOutsideClick: false,
               width: '100%',
               grow: 'fullscreen',
               css_popup: 'swalPopup_theme_1',
            });
         }

         device_picker();
      });
   }


   update_club_ads = (sport_type) => {
      return new Promise(async (resolve) => {
         try {
            const club_details = await this.db_handler.load_club();
            const club_ads = await this.apt_control.SME.query.club_ads(club_details.club_id, sport_type);
            const club_update = {
               ad_1: club_ads.ad1.path,
               ad_2: club_ads.ad2.path,
               ad_3: club_ads.ad3.path
            }
            const update_club_result = await this.db_handler.update_club(club_update);

            if (!update_club_result) {
               console.error('Error update_club_ads: Unexpected Error');
               resolve(false);
               return;
            }

            resolve(true);
         } catch (error) {
            console.error('Error update_club_ads: Unexpected Error: ', error);
            resolve(false);
         }
      });
   }

   // register_court = (court_details) => {
   //    return new Promise(async (resolve) => {
   //       const select_court = (ccfg_id) => {
   //          const selected_court = court_details.filter(i => i.ccfg_id === ccfg_id);
   //          ConfirmModel({
   //             title: `Confirm Selection`,
   //             html: (<RegisterDevice court_details={selected_court} />),
   //             confirmButtonText: 'Yes',
   //             showCancelButton: true,
   //             allowOutsideClick: true,
   //          }).then((result) => {
   //             if (result.isConfirmed) {
   //                /// Need to Config the next court with this device....
   //                // Planning here
   //                // We know the court we need.
   //                // But we still need a device Nick name
   //                // Need to Sync a device to a court.
   //                // How to handle devices
   //                resolve(selected_court[0]);
   //             } else {
   //                court_picker();
   //             }
   //          });
   //       }
   //       const court_picker = () => {
   //          ConfirmModel({
   //             // icon: 'error',
   //             title: `Sync Court`,
   //             // text: ``,
   //             html: (<RegisterDevice court_details={court_details} selectCallback={select_court} />),
   //             confirmButtonText: 'Ok',
   //             cancelButtonText: 'Skip',
   //             showConfirmButton: false,
   //             showCancelButton: true,
   //             allowOutsideClick: false,
   //          }).then((result) => {
   //             console.log('>>> court_picker result: ', result)
   //             if (result.isDismissed) {
   //                resolve(false)
   //             }
   //          });
   //       }
   //       court_picker();
   //    });
   // }



   repair_stale_unsynced_matches = async (un_synced_matches) => {
      return new Promise(async (resolve) => {
         try {
            const running_matches = un_synced_matches.filter(i => i.match_state === 'running');

            if (running_matches.length > 1) {
               running_matches.sort((a, b) => {
                  return a.id - b.id;
               });

               console.error('repair_stale_unsynced_matches: ', un_synced_matches);
               running_matches[0].match_state = 'completed';
               for (let a = 0; a < running_matches[0].games[a].length; a++) {
                  running_matches[0].games[a].state = 'complete'; 
               }

               await this.db_handler.updateMatch(running_matches[0].id, running_matches[0], false, 'Repair Stale Unsynced Matches');
              
            }

            resolve(true);
         } catch (error) {
            console.error('ERROR - repair_stale_unsynced_matches - unexpected error: ', error);
            resolve(false);
         }
      });
   }
   

   sync_watch = () => {
      return new Promise(async (resolve) => {
         try {
            // console.log('[DEBUG] ------------***** sync_watch - Starting');
            const data_check = 15;
            this.SYNC_WATCH_COUNT ++;
            if (this.SYNC_WATCH_COUNT % data_check === 0) { await this.update_sync_data(); }

            if (GLOBAL_VARS.free_app === false || isHotLoad()) {
               console.debug('%c [BACKEND - SYNC] >>> SYNC WATCH', 'background: #222; color: lightgreen');
               const matchList = await this.db_handler.loadAllMatches();
               // console.warn('[DEBUG-SYNC] Loaded matches from DB, checking cast_data:', matchList.map(m => ({ id: m.id, clear: m.cast_data?.info_pop_up?.clear, title: m.cast_data?.info_pop_up?.title })));
               // console.log('[DEBUG] ------------***** sync_watch - matchList: ', matchList.length);
               // console.log('check - matchList: ', matchList.length);
               // const un_synced_matches = matchList.filter(i => i.synced === 0);
               const un_synced_matches = matchList.filter(i => i.synced === 0 && i.match_killed === false);
               // console.log('un_synced_matches: ', un_synced_matches);

               if (un_synced_matches.length === 0) { resolve(true); return }
               const sync = await this.db_handler.load_sync();
               const account = await this.db_handler.load_account();
               const match_const = {
                  user_id: parseInt(account.user_id),
                  device_id: parseInt(sync.device_id),
                  ccfg_id: parseInt(sync.ccfg_id),
               }

               await this.repair_stale_unsynced_matches(un_synced_matches);

               console.debug('%c [BACKEND - SYNC] >>> DEBUG >>> sync_watch >> account', 'background: #222; color: pink', account);
               console.debug('%c [BACKEND - SYNC] >>> DEBUG >>> sync_watch >> sync', 'background: #222; color: pink', sync);
               console.debug('%c [BACKEND - SYNC] >>> DEBUG >>> sync_watch >> matchList', 'background: #222; color: pink', matchList);
               console.debug('%c [BACKEND - SYNC] >>> sync_watch >> match_const', 'background: #222; color: pink', match_const);
               console.debug('%c [BACKEND - SYNC] >>> sync_watch >> un_synced_matches', 'background: #222; color: pink', un_synced_matches);

               if (un_synced_matches.length > 1) {
                  console.warn('[SYNC-BACKLOG] un_synced_matches Count: ', un_synced_matches.length);
                  console.warn('[SYNC-BACKLOG] un_synced_matches: ', un_synced_matches);
               }

               for (let a = 0; a < un_synced_matches.length; a++) {
                  console.debug('%c [BACKEND - SYNC] >>> sync_match START', 'background: #222; color: lightgreen');

                  // await update_cast_settings();
                  const result = await this.sync_match(match_const, un_synced_matches[a]);
                  console.debug('%c [BACKEND - SYNC] >>> sync_match result', 'background: #222; color: lightgreen', result);
                  if (a + 1 < un_synced_matches.length) {
                     await Sleep(500);
                  }
               }

               resolve(true);
            } else {
               console.debug('%c [BACKEND - SYNC] >>> SYNC WATCH -- NO SYNC WHILE FREE APP', 'background: #222; color: lightgreen');
               await Sleep(10_000);
               resolve(true);
            }
         } catch (error) {
            console.error('ERROR - Sync - sync_watch - unexpected error: ', error);
            resolve(false);
         }
      });
   }

   sync_match = (match_const = null, match = null) => {
      return new Promise(async (resolve) => {
         try {
            console.debug('[DEBUG] >>>>>>>>>>> SYNC MATCH');
            // CRITICAL FIX: Reload match from DB to get freshest data (including recent speech_text)
            // The match passed in was loaded at the start of sync_watch, but new data may have been
            // saved while sync was running. We need the absolute latest data before pushing to server.
            const fresh_match = await this.db_handler.loadMatch(match.id);
            if (fresh_match) {
               match = fresh_match;
            }
            
            console.debug('%c [BACKEND - SYNC] >>> sync_match Start', 'background: #222; color: red', match);

            let p1game = 0;
            let p2game = 0;
            for (let a = 0; a < match.games.length; a++) {
               if (match.games[a].winner === 1) { p1game++; }
               else if (match.games[a].winner === 2) { p2game++; }
            }
            const player_type = match.push_match.tc_id === 0 && match.push_match.t_id === 0 ? 'Quick Match' : 'Member';
            const best_of = typeof match.settings.games_per_match !== 'undefined' ? parseInt(match.settings.games_per_match) : 0;
            const tiebreak_points = typeof match.settings.tb_points !== 'undefined' ? parseInt(match.settings.tb_points) : 0;
            const match_option = typeof match.settings.match_options !== 'undefined' ? parseInt(match.settings.match_options) + 1 : 2;
            const deciding_match = typeof match.settings.deciding_match !== 'undefined' ? parseInt(match.settings.deciding_match) : 0;
            const dec_m_winby = typeof match.settings.tb_win_by !== 'undefined' ? parseInt(match.settings.tb_win_by) : 0;
            const continuous_options = typeof match.settings.continuous_options !== 'undefined' ? parseInt(match.settings.continuous_options) : 0
            const maximum_score = typeof match.settings.maximum_score !== 'undefined' ? parseInt(match.settings.maximum_score) : 0;
            const maximum_score_opt = typeof match.settings.maximum_score_opt !== 'undefined' ? parseInt(match.settings.maximum_score_opt) : 0;
            const score_freeze = typeof match.settings.score_freeze !== 'undefined' ? parseInt(match.settings.score_freeze) : 0;
            const game_points = typeof match.settings.points_per_game !== 'undefined' ? parseInt(match.settings.points_per_game) : 0;
            const win_by = typeof match.settings.win_by !== 'undefined' ? match.settings.win_by + '' : '';

            // console.log('match.settings: ', match.settings);
            // game_options
            // console.log('match.cast_data: ', match.cast_data.cast_speech_rate);

            const match_extra = {
               mid: match.mid,
               background: match.cast_data.background,
               cast_border_size: parseInt(match.cast_data.cast_border_size),
               cast_speech_rate: parseFloat(match.cast_data.cast_speech_rate),
               cast_voice: match.cast_data.cast_voice,
               info_pop_up: match.cast_data.info_pop_up,
               mute: match.cast_data.mute ? 1 : 0,
               speech_text: match.cast_data.speech_text.texts
            }

            // console.log('[DEBUG] >>> match_extra: ', match_extra);
            // const match_date_last_updated = new Date().toISOString();
            // console.log('match_date_last_updated: ', match_date_last_updated);
            
            // >>>>>>>>>>>>>>>>>> Sync Match
            const create_match_result = await this.apt_control.SME.mutation.push_match(match.uuid, {
               user_id: match_const.user_id,
               match_code: match.match_code,
               player1: match.settings.player_a,
               player2: match.settings.player_b,
               player3: typeof match.settings.player_c !== 'undefined' ? match.settings.player_c : '',
               player4: typeof match.settings.player_d !== 'undefined' ? match.settings.player_d : '',
               match_type: match.push_match.match_type !== '' ? match.push_match.match_type : 'QM',
               completed: match.winner === '' ? '0' : '1',
               // player_country
               game_points: game_points !== null && !isNaN(game_points) ? game_points : 0,
               best_of: best_of !== null && !isNaN(best_of) ? best_of : 1,
               win_by: win_by !== null ? win_by : '',
               p1game: p1game,
               p2game: p2game,
               date: Get_Date(),
               timelimit: typeof match.settings.continuous_time !== 'undefined' ? parseInt(match.settings.continuous_time) : 0,
               p1code: parseInt(match.players.teams[0].players[0].id),
               p2code: parseInt(match.players.teams[1].players[0].id),
               p3code: typeof match.players.teams[0].players[1] !== 'undefined' ? parseInt(match.players.teams[0].players[1].id) : 0,
               p4code: typeof match.players.teams[1].players[1] !== 'undefined' ? parseInt(match.players.teams[1].players[1].id) : 0,
               deviceid: match_const.device_id,
               groupid: match.push_match.t_id,
               p1_Type: player_type,
               p2_Type: player_type,
               p3_Type: player_type,
               p4_Type: player_type,
               sport_type: match.sport,
               // match_graded
               // win_by_pmt
               // win_by_pmt_dec
               match_option: match_option !== null && !isNaN(match_option) ? match_option : 2,
               // point_b_points
               // score_opt
               // match_max_points
               // match_select_sport
               deciding_match: deciding_match !== null && !isNaN(deciding_match) ? deciding_match : 0,
               tiebreak_points: tiebreak_points !== null && !isNaN(tiebreak_points) ? tiebreak_points : 0,
               dec_m_winby: dec_m_winby !== null && !isNaN(dec_m_winby) ? dec_m_winby : 0,
               continuous_options: continuous_options !== null && !isNaN(continuous_options) ? continuous_options : 0,
               maximum_score: maximum_score !== null && !isNaN(maximum_score) ? maximum_score : 0,
               maximum_score_opt: maximum_score_opt !== null && !isNaN(maximum_score_opt) ? maximum_score_opt : 0,
               score_freeze: score_freeze !== null && !isNaN(score_freeze) ? score_freeze : 0,
               uuid: match.uuid,
               // match_defaulted_player
               // source
               ccfg_id: match_const.ccfg_id,
               p1_color: match.settings.player_a_color,
               p2_color: match.settings.player_b_color,
               p3_color: typeof match.settings.player_c_color !== 'undefined' ? match.settings.player_c_color : '',
               p4_color: typeof match.settings.player_d_color !== 'undefined' ? match.settings.player_d_color : '',
               match_extra: match_extra,
               game_options: match?.settings?.game_options? parseInt(match?.settings?.game_options) : 0,
            });
            console.debug('%c [BACKEND - SYNC] >>> push_match result', 'background: #222; color: red', create_match_result);
            // console.warn('%c [BACKEND - SYNC] >>> push_match result', 'background: #222; color: red', create_match_result);


            if (create_match_result.block_score_sync === 1) {
               console.error('ERROR - sync_match - Block Score Sync');
               SPORT_BASE.sport_object.scoring.state.match.match_killed = true;
               this.update_match(match.id, { match_killed: true }, 'Match-Killed');
               resolve(false);
               return;
            }


            if (create_match_result !== false) {
               match.mid = parseInt(create_match_result.mid);

               if (match.mid === null || isNaN(match.mid)) {
                  console.error('ERROR - sync_match - Match MID is null or NaN');
                  resolve(false);
                  return;
               }
               
               this.update_match(match.id, { mid: match.mid }, 'Match-MID');
               this.apply_mid(match.match_code, match.mid);

               if (match.sync_error === 0 && match.match_state !== 'match_won') {
                  this.push_match_sync(match, create_match_result.mid, match_const.device_id);
               }
               
               
               // >>>>>>>>>>>>>>>>>> Sync Match Relation
               const games_to_sync = [];
               for (let a = 0; a < match.games.length; a++) {
                  Date_Convert_Timezone(dayjs(), 'Etc/GMT')

                  const  start_time_UTC = dayjs(match.games[a].start_time);
                  const  end_time_UTC = match.games[a].end_time !== null ? dayjs(match.games[a].end_time) : Get_Date();
                  const winner_name = match.games[a].winner === 1 ? match.settings.player_a : match.games[a].winner === 2 ? match.settings.player_b : '';
                  const serving_side = match.games[a].serving_side;
                  const serving_player = match.games[a].serving_player;
                  const serving_inner_side = match.games[a]?.serving_inner_side;
 
                  games_to_sync.push({
                     mrid: match.games[a].mrid,
                     mid: match.mid,
                     p1l: match.games[a].team_1_score,
                     // p1r
                     p2l: match.games[a].team_2_score,
                     // p2r
                     points: match.settings.points_per_game + '',
                     winby: winner_name,
                     start_time: start_time_UTC.valueOf(),
                     end_time: end_time_UTC.valueOf(),
                     // breaktime
                     // break_reason
                     game_status: match.match_state,
                     serve_pos: serving_player,
                     serve_side: serving_side,
                     serving_inner_side: serving_inner_side, // This needs to be added to the DB First
                     p1_pre_score: typeof match.games[a].team_1_score_pre !== 'undefined' ? match.games[a].team_1_score_pre : 0,
                     p2_pre_score: typeof match.games[a].team_2_score_pre !== 'undefined' ? match.games[a].team_2_score_pre : 0,
                     pre_score: typeof match.games[a].tennis_pre_score !== 'undefined' ? match.games[a].tennis_pre_score : false,
                     last_call_text: typeof match.games[a].last_call_text !== 'undefined' ? match.games[a].last_call_text : '',
                     deviceid: match_const.device_id,
                     ccfg_id: match_const.ccfg_id
                  });
               }

               const sync_match_rel_result = await this.apt_control.SME.mutation.sync_match_relation(match.mid, games_to_sync);
               if (sync_match_rel_result !== false) {
                  const update_obj = { games: [] }
                  for (let a = 0; a < match.games.length; a++) {
                     if (typeof sync_match_rel_result[a] !== 'undefined') {
                        match.games[a].mrid = parseInt(sync_match_rel_result[a].mrid);
                        update_obj.games[a] = { mrid: parseInt(sync_match_rel_result[a].mrid) }
                     }
                  }

                  this.update_match(match.id, update_obj, 'Games-MRID');
                  this.apply_mrid(match.match_code, update_obj);
               }
               console.debug('%c [BACKEND - SYNC] >>> sync_match_relation result', 'background: #222; color: red', sync_match_rel_result);

               // >>>>>>>>>>>>>>>>>> Sync Match Logs
               const update_obj = { games: [] }
               for (let a = 0; a < match.games.length; a++) {
                  update_obj.games[a] = {
                     synced: 0,
                     logs: [],
                  }
                  const logs_to_sync = [];
                  for (let b = 0; b < match.games[a].logs.length; b++) {
                     const action = this.convert_log_action(match.games[a].logs[b]);
                     // const log_timestamp_UTC = Date_Convert_Timezone(dayjs(match.games[a].logs[b].timestamp), 'Etc/GMT');
                     const log_timestamp_UTC = dayjs(match.games[a].logs[b].timestamp);
                     
                     // console.log('match.games[a].logs[b].timestamp: ', match.games[a].logs[b].timestamp);
                     // console.log('log_timestamp_UTC: ', log_timestamp_UTC);
                     // console.log('log_timestamp_UTC.valueOf(): ', log_timestamp_UTC.valueOf());

                     logs_to_sync.push({
                        ml_id: parseInt(match.games[a].logs[b].ml_id),
                        mrid: match.games[a].mrid,
                        // breakt: 
                        ml_action: action,
                        ml_content: match.games[a].logs[b].content,
                        ml_logsts: 1,
                        // ml_logtime: match.games[a].logs[b].timestamp, // OLD - NEED TO REMOVE
                        ml_logtime: log_timestamp_UTC.valueOf(),

                        // serv_side: typeof match.games[a].logs[b].server_side !== 'undefined' ? match.games[a].logs[b].server_side + '' : '', // Need to Find why the logs are being send out like this. (Issue is else where)
                        serv_side: match.games[a].logs[b].server_side + '',
                        server: match.games[a].logs[b].server_player,
                        // timestamp: match.games[a].logs[b].timestamp,
                     });
                  }
                  const sync_log_result = await this.apt_control.SME.mutation.sync_match_logs(match.games[a].mrid, logs_to_sync);
                  if (sync_log_result !== false) {
                     for (let b = 0; b < match.games[a].logs.length; b++) {
                        if (typeof sync_log_result[b] !== 'undefined') {
                           match.games[a].logs[b].synced = 1;
                           match.games[a].logs[b].ml_id = sync_log_result[b].ml_id;
                           update_obj.games[a].logs[b] = { synced: 1, ml_id: parseInt(sync_log_result[b].ml_id) }
                        }
                     }
                     this.update_match(match.id, update_obj, 'Logs-MLID');
                     this.apply_mlid(match.match_code, update_obj);
                  }
                  console.debug('%c [BACKEND - SYNC] >>> sync_log_result result', 'background: #222; color: red', sync_log_result);

                  // if (winner_name !== '') {
                  if (match.games[a].state === 'complete') {
                     match.games[a].synced = 1;
                     update_obj.games[a].synced = 1;
                     this.update_match(match.id, update_obj, 'Game-Complete');
                  }
               }

               if (match.winner !== '') {
                  const match_validation = await this.validate_synced_match(match);
                  console.debug('%c [BACKEND - SYNC] >>> match_validation result', 'background: #222; color: red', match_validation);
                  console.debug('match_validation: ', match_validation, match);

                  // console.log('match.winner: ', match.winner);


                  if (match_validation.result) {
                     if (match.push_match.t_id !== 0) {

                     // if (match.push_match.tc_id > 0) {
                        await this.push_match_sync_finish(match);
                        const match_complete_result = await this.apt_control.SME.mutation.run_match_complete(match.uuid);
                        console.log('match_complete_result: ', match_complete_result.Result);


                        if (match_complete_result.Result) {
                           match.synced = 1;
                           this.update_match(match.id, { synced: 1 }, 'Match-Synced');
                        } else if (match.sync_error > 10) {
                           console.error('ERROR - run_match_complete - retries exhausted, giving up');
                           match.synced = 1;
                           this.update_match(match.id, { synced: 1 }, 'Match-Synced');
                        } else {
                           console.error('ERROR - run_match_complete failed, Retrying');
                           match.sync_error += 1;
                           this.update_match(match.id, { sync_error: match.sync_error }, 'Match-Sync-Error');
                        }
                     } else {
                        match.synced = 1;
                        this.update_match(match.id, { synced: 1 }, 'Match-Synced');
                     }
                  } else {
                     console.warn('Match Validation Failed: ', match_validation);
                  }
               } else if (match.match_state === 'match_cleared') {
                  console.debug('%c [BACKEND - SYNC] >>> Match Cleared', 'background: #222; color: red');
                  match.synced = 1;
                  this.update_match(match.id, { synced: 1 }, 'Match-Synced');
                  await this.push_match_sync_finish(match, 2);
               } else {
                  // >>> Marks a Match as Active Match on the Device and Court.
                  // >>> We should only Do this for the Active Match. (Not Completed Matches or Old Stale Matches)
                  const is_active = await is_active_match(match.id);
                  
                  if (is_active === true) {
                     // console.log('Marking Match as Active Match: ', match.id);
                     if (!isHotLoad()) {
                        const update_device_match = await this.apt_control.SME.mutation.update_device(match_const.device_id, {
                           current_match: match.games[match.games.length - 1].mrid,
                           sport_type: match.sport,
                           access_date: Get_Date(),
                        });
                        console.debug('%c [BACKEND - SYNC] >>> update_device_match result', 'background: #222; color: red', update_device_match);
                     }
                     const update_court_match = await this.apt_control.SME.mutation.update_court(match_const.ccfg_id, {
                        mid: match.mid,
                        access_date: Get_Date(),
                     });
                     console.debug('%c [BACKEND - SYNC] >>> update_court_match result', 'background: #222; color: red', update_court_match);
                  } else {
                     console.warn('Match is not Active SKIPPING...');
                  }
               }

               await this.db_handler.update_sync({ device_id: match_const.device_id });
            }
            resolve(true);
         } catch (error) {
            console.error('ERROR - Sync - sync_match - unexpected error: ', error);
            resolve(false);
         }
      });
   }

   validate_synced_match = (match) => {
      return new Promise(async (resolve) => {
         try {
            const full_match = await this.apt_control.SME.query.match_full(match.mid);
            // console.log('>>>>>>>>> full_match: ', full_match);
            // console.log('>>>>>>>>> match: ', match);
            let synced = true;
            for (let a = 0; a < match.games.length; a++) {
               if (match.games[a].synced === 0) {
                  synced = false;
               } else {
                  for (let b = 0; b < match.games[a].logs.length; b++) {
                     if (match.games[a].logs[b].synced === 0) {
                        synced = false;
                        match.games[a].synced = 1;
                     }
                  }
               }
            }

            let failed_reason = [];

            if (synced) {
               let match_error = false;
               let p1game = 0;
               let p2game = 0;
               for (let a = 0; a < match.games.length; a++) {
                  if (match.games[a].winner === 1) { p1game++; }
                  else if (match.games[a].winner === 2) { p2game++; }
               }
               if (typeof match.settings.win_by !== 'undefined' && full_match.match.win_by + '' !== match.settings.win_by + '') { 
                  // TODO: Not 100% sure why this is needed. can remove if causing an issue.
                  match_error = true; 
                  failed_reason.push('Win By Settings Mismatch');
               }
               if (full_match.match.completed !== "1") { 
                  match_error = true; 
                  failed_reason.push('Match Not Completed');
               }
               if (full_match.match.p1game !== p1game) { 
                  match_error = true; 
                  failed_reason.push('Player 1 Game Score Mismatch');
               }
               if (full_match.match.p2game !== p2game) { 
                  match_error = true; 
                  failed_reason.push('Player 2 Game Score Mismatch');
               }
               console.debug('DEBUG >>> validate_synced_match >> match_error: ', match_error);

               // TODO: Add to this if match sync invalid
               if (match_error === false) {
                  resolve({
                     result: true,
                     reason: '',
                  });
                  return;
               }
            }

            resolve({
               result: false,
               reason: failed_reason,
            });
         } catch (error) {
            console.error('ERROR - Sync - validate_synced_match - unexpected error: ', error);
            resolve({
               result: false,
               reason: 'Unexpected Error',
            });
         }
      });
   }

   convert_log_action = (log) => {
      let action = '';
      // console.debug('DEBUG >> convert_log_action log: ', log);
      if (log.action === 'P') {
         if (log.score_side === 1 && log.content === 'HO') { action = 'p1ho'; }
         else if (log.score_side === 1 && log.server_inner_side === 1) { action = 'p1l'; }
         else if (log.score_side === 1 && log.server_inner_side === 2) { action = 'p1r'; }
         else if (log.score_side === 2 && log.content === 'HO') { action = 'p2ho'; }
         else if (log.score_side === 2 && log.server_inner_side === 1) { action = 'p2l'; }
         else if (log.score_side === 2 && log.server_inner_side === 2) { action = 'p2r'; }
      } else {
         action = log.action;
      }
      // console.debug('DEBUG >> convert_log_action action: ', action);
      return action;
   }


   connection_watch = async () => {
      // Prevent multiple instances from running
      if (this.connection_watch_running) {
         console.debug('connection_watch already running, skipping');
         return;
      }
      
      this.connection_watch_running = true;
      
      try {
         console.debug('>>> connection_watch <<<');
         this.apt_control.SME.subscription.keep_alive(0, async (result) => {
            console.debug('Heart Beat: ', result.sts);
            if (result.sts === false) {
               GLOBAL_VARS.server_connection = false;
               console.error('ERROR - connection_watch: Connection Lost');
               this.connection_watch_running = false;
               await Sleep(5000);
               this.connection_watch();
               return
            }

            const lastDate = new Date(parseInt(result.data.last_update));
            const currentDate = new Date();
            GLOBAL_VARS.keep_alive_seconds = Math.floor((currentDate - lastDate) / 60);
            GLOBAL_VARS.server_connection = true;
         });
      } catch (error) {
         console.error('ERROR - connection_watch: ', error);
         GLOBAL_VARS.server_connection = false;
         this.connection_watch_running = false;
         Sleep(10_000);
         this.connection_watch();
      }
   }

   update_match = (match_id, update, tag = '') => {
      return new Promise(async (resolve) => {
         try {
            await UsingLock(LOCKS.update_match_lock, async () => { 
               // CRITICAL FIX: Use Dexie's where().modify() to update in-place without loading into memory first
               // This prevents overwriting newer speech_text/cast_data with stale data during sync
               // modify() reads directly from DB, merges changes, and writes back atomically
               const result = await db.matches.where('id').equals(match_id).modify((match) => {
                  // Deep merge the update into the existing match
                  // This preserves data in fields not being updated (like speech_text)
                  merge(match, update);
               });
               resolve(result);
            });
         } catch (error) {
            console.error('ERROR - Sync - update_match: ', error);
            resolve(false);
         }
      });
   }

   apply_mid = (match_code, mid) => {
      if (SPORT_BASE.sport_object.scoring.state.match.match_code === match_code) {
         SPORT_BASE.sport_object.scoring.state.match.mid = mid;
      }
   }

   apply_mrid = (match_code, update_obj) => {
      if (SPORT_BASE.sport_object.scoring.state.match.match_code === match_code) {
         for (let a = 0; a < SPORT_BASE.sport_object.scoring.state.match.games.length; a++) {
            if (typeof update_obj.games[a] !== 'undefined') {
               SPORT_BASE.sport_object.scoring.state.match.games[a].mrid = update_obj.games[a].mrid;
            }
         }
      }
   }

   apply_mlid = (match_code, update_obj) => {
      if (SPORT_BASE.sport_object.scoring.state.match.match_code === match_code) {
         for (let a = 0; a < SPORT_BASE.sport_object.scoring.state.match.games.length; a++) {
            if (typeof update_obj.games[a] !== 'undefined') {
               for (let b = 0; b < SPORT_BASE.sport_object.scoring.state.match.games[a].logs.length; b++) {
                  if (typeof update_obj.games[a].logs[b] !== 'undefined') {
                     SPORT_BASE.sport_object.scoring.state.match.games[a].logs[b].ml_id = update_obj.games[a].logs[b].ml_id;
                     SPORT_BASE.sport_object.scoring.state.match.games[a].logs[b].synced = update_obj.games[a].logs[b].synced;
                  }
               }
            }
         }
      }
   }


   push_match_sync = (match, mid, device_id) => {
      try {
         if (match.push_match.t_id !== 0) {
            this.apt_control.SME.mutation.update_push_match(match.push_match.load_mid, {
               mid: parseInt(mid),
               device_id: device_id + '',
               loaded_status: 3,
            }).then((result) => {
               console.debug('%c [BACKEND - SYNC] >>> push_match_sync result', 'background: white; color: purple', result);
            });
         }
      } catch (error) {
         console.error('ERROR - Sync - push_match_sync - unexpected error: ', error);
      }
   }

   push_match_sync_finish = (match, state = 4) => {
      return new Promise(async (resolve) => {
         try {
            if (match.push_match.t_id !== 0) {
               const result = await this.apt_control.SME.mutation.update_push_match(match.push_match.load_mid, {
                  mid: null,
                  device_id: null,
                  loaded_status: state,
               });
               console.debug('%c [BACKEND - SYNC] >>> push_match_sync_finish result', 'background: white; color: purple', result);
               resolve(true);
            } else {
               resolve(false);
            }
         } catch (error) {
            console.error('ERROR - Sync - push_match_sync_finish - unexpected error: ', error);
            resolve(false);
         }
      });
   }

}


export default Sync;